<div class="edit-page-root-container job-position-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="50" [readonly]="jobPositionInfo.id!==undefined && jobPositionInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name" maxlength="100" [readonly]="true">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Name is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field>
                                    <mat-label>Hierarchy Order</mat-label>
                                    <input matInput type="number" formControlName="hierarchy_order" [readonly]="true">
                                </mat-form-field>
                            </div>
                            <div class="input-box-right">
                                <mat-form-field>
                                    <mat-label>Grade</mat-label>
                                    <input matInput type="number" formControlName="grade">
                                    <mat-error *ngIf="editForm.controls['grade'].hasError('min')">Grade cannot be negative</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left" style="display: flex; align-items: center; gap: 20px; padding-bottom: 20px;">
                                <mat-checkbox formControlName="is_hq" [disabled]="true">Is HQ</mat-checkbox>
                                <mat-checkbox formControlName="is_active" [disabled]="true">Is Active</mat-checkbox>
                                <mat-checkbox formControlName="receive_roster_by_mail" [disabled]="!permission.can_edit">Receive Roster By Mail</mat-checkbox>
                            </div>
                            <div class="input-box-right" style="display: flex; gap: 10px;">
                                <mat-form-field style="flex: 1;">
                                    <mat-label>FG Color</mat-label>
                                    <input matInput type="color" formControlName="fg_color" style="height: 30px; padding: 0;">
                                </mat-form-field>
                                <mat-form-field style="flex: 1;">
                                    <mat-label>BG Color</mat-label>
                                    <input matInput type="color" formControlName="bg_color" style="height: 30px; padding: 0;">
                                </mat-form-field>
                            </div>
                        </div>

                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description" [readonly]="true"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
